<template>
  <div class="flex flex-col items-center justify-center mt-10">

    <div class="mx-auto mt-2 font-bold text-center">
      <div
        v-text="title"
        class=" text-xl block mx-auto px-5 text-center "
        style="width: fit-content"
        :style="{ color: survey.fontColor, 'font-family': survey.fontFamily }"
      ></div>
    </div>
    <div class="mx-auto text-center mt-1">
      <div
        v-text="subtitle"
        class="block mx-auto px-5 text-center"
        style="width: fit-content"
        :style="{ color: survey.fontColor, 'font-family': survey.fontFamily }"
      ></div>
    </div>

    <div class="my-10">
      <div v-if="step.image !== null">
        <div class="flex flex-row justify-center items-center">

          <div class="display-block mx-auto cursor-pointer rounded">
            <img
              v-if="step.image == 'link'"
              :src="step.image_link"
            />
            <svg-inline
              v-else
              class=" h-28 "
              style="width: fit-content"
              :style="{ color: survey.accentColor }"
              :image="step.image"
            />
          </div>
        </div>
      </div>
    </div>

    <SurveyButton :survey="survey" :step="step" @click="$emit('goto-next')" />

  </div>
</template>

<script>
import Step from "@/models/Step";
import SurveyButton from "@/components/Survey/SurveyButton.vue";

export default {
  props: ["survey", "step"],
  data() {
    return {
 
    };
  },
  components: {

    SurveyButton,
  },
  computed: {
    title: {
      get() {
        return this.step.title;
      },
      set(value) {
        if (value !== this.step.title) {
          Step.update({
            where: this.step.id,
            data: {
              title: value,
            },
          });
        }
      },
    },
    subtitle: {
      get() {
        return this.step.subtitle;
      },
      set(value) {
        if (value !== this.step.subtitle) {
          Step.update({
            where: this.step.id,
            data: {
              subtitle: value,
            },
          });
        }
      },
    },
  },
  methods: {
    removeImage() {
      Step.update({
        where: this.step.id,
        data: {
          image: null,
        },
      });
    },
  },
};
</script>

<style></style>
